import { FC, useEffect, useState } from 'react';
import { getBonusRequestsById } from '../../../../services';
import { Spinner } from 'flowbite-react';
import { Table } from 'flowbite-react';
import { formatDate } from '../../../../utils';

interface IBonusRequests {
  id: string;
}

interface DailyBonusRequest {
  date: string;
  bonusRequestCount: number;
}

interface BonusRequestsData {
  totalBonusRequests: number;
  dailyBonusRequests: DailyBonusRequest[];
}

export const BonusRequests: FC<IBonusRequests> = ({ id }: IBonusRequests) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [response, setResponse] = useState<BonusRequestsData | null>(null);

  const renderData = (data: BonusRequestsData) => {
    const totalBonusRequests = data.dailyBonusRequests.reduce(
      (acc: number, cur: DailyBonusRequest) => acc + cur.bonusRequestCount,
      0,
    );

    const processedData: BonusRequestsData = {
      ...data,
      totalBonusRequests,
      dailyBonusRequests: data.dailyBonusRequests,
    };

    console.log('Processed data: ', processedData);
    setResponse(processedData);
  };

  const fetchData = async (id: string) => {
    try {
      const res: any = await getBonusRequestsById(id);
      renderData(res.data);
    } catch (error) {
      console.error('fetchData: ', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(id);
  }, [id]);

  return (
    <>
      {loading ? (
        <div className="text-center">
          <Spinner />
        </div>
      ) : (
        <div className="overflow-x-auto max-h-80">
          <Table hoverable>
            <Table.Head>
              <Table.HeadCell></Table.HeadCell>
              <Table.HeadCell className="text-right">Bonus</Table.HeadCell>
            </Table.Head>
            <Table.Body>
              {response?.dailyBonusRequests.map((item: DailyBonusRequest) => {
                const { date, bonusRequestCount } = item;
                return (
                  <Table.Row key={date}>
                    <Table.Cell>{formatDate(date)}</Table.Cell>
                    <Table.Cell className="text-right">
                      {bonusRequestCount}
                    </Table.Cell>
                  </Table.Row>
                );
              })}
              <Table.Row>
                <Table.Cell></Table.Cell>
                <Table.Cell className="text-right">
                  {response?.totalBonusRequests}
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
      )}
    </>
  );
};
